/**
 * Number and percentage formatting utilities
 */

/**
 * Formats a number with grouping separators (commas)
 * @param number - The number to format
 * @returns Formatted string with grouping separators, or empty string if null/undefined
 * @example
 * formatNumber(1234.56) // "1,234.56"
 * formatNumber(null) // ""
 */
export const formatNumber = (number: number): string => {
  if (number == null) return "";
  return Number(number).toLocaleString(undefined, { useGrouping: true });
};

/**
 * Formats a number as a percentage with specified precision
 * @param number - The number to format
 * @param precision - Number of decimal places (default: 2)
 * @returns Formatted percentage string, or empty string if invalid
 * @example
 * formatNumberPct(0.1234, 2) // "0.12%"
 * formatNumberPct(null) // ""
 */
export const formatNumberPct = (
  number: number | null | undefined,
  precision: number = 2
): string => {
  if (number == null || isNaN(Number(number))) return "";
  return `${Number(number).toFixed(precision)}%`;
};